import React from 'react'
import './KnowMore.css'

const KnowMore = () => {
  return (
    <div className='knowmore-footer'>
        <h1>To know more!</h1>
        <p className='km-footer'>Create an account for free and join our thousands of happy members.</p>
        <button className='km-button'>Register Now</button>
    </div>
  )
}

export default KnowMore